import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFFILIATES_REQUEST_HISTORY = Symbol('affiliates.request-history');

export const AFFILIATES_REQUEST_HISTORY_ROUTE_NAME = Symbol('affiliates.request-history');
export const AFFILIATES_REQUEST_HISTORY_LIST_ROUTE_NAME = Symbol('affiliates.request-history.list');

export const AFFILIATES_REQUEST_HISTORY_LIST_URL = 'admin/affiliates/list_requests_history';
export const AFFILIATES_REQUEST_HISTORY_LIST_QUERY_KEY = 'affiliates.request-history.list';

export const AFFILIATES_REQUEST_HISTORY_LIST_REPORT_URL = 'admin/affiliates/download_list_requests_history';
export const AFFILIATES_REQUEST_HISTORY_DOWNLOAD_LIST_MUTATION_KEY = 'affiliates.request-history.download-list';

export const AFFILIATES_REQUEST_HISTORY_CHANGE_STATUS_URL = 'admin/affiliates/:id/rehabilitate_request';
export const AFFILIATES_REQUEST_HISTORY_CHANGE_STATUS_MUTATION_KEY = 'affiliates.request-history.change-status';

export const AFFILIATES_REQUEST_HISTORY_PROFILE_ROUTE_NAME = Symbol('affiliates.request-history.profile');
export const AFFILIATES_REQUEST_HISTORY_REAPPROVE_ROUTE_NAME = Symbol('affiliates.request-history.reapprove');

export const AFFILIATES_REQUEST_HISTORY_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.AFFILIATES_SHOW),
  DOWNLOAD_LIST: new Permission(PermissionsList.admin.AFFILIATES_DOWNLOAD_LIST_REQUESTS_HISTORY),
  CHANGE_STATUS: new Permission(PermissionsList.admin.AFFILIATES_WITHDRAW_FROM_STATUS_DENIED),
};
